import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Button, Container, Stack, Text, Title } from '@mantine/core'

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
}

/**
 * Глобальный предохранитель: без него необработанное исключение в любом
 * компоненте = белый экран без объяснений. Рендерим понятный fallback
 * с кнопкой перезагрузки и пишем стек в console для диагностики.
 */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <Container size="sm" pt={80}>
        <Stack align="center" gap="md">
          <Title order={2}>Что-то пошло не так</Title>
          <Text c="dimmed" ta="center">
            Произошла непредвиденная ошибка интерфейса. Перезагрузите страницу —
            данные не потеряны. Если повторяется, сообщите администратору.
          </Text>
          <Text size="sm" c="red" ff="monospace">
            {this.state.error.message}
          </Text>
          <Button onClick={() => window.location.reload()}>Перезагрузить страницу</Button>
        </Stack>
      </Container>
    )
  }
}
